import { copyToClipboard } from "../src/utils/clipboard";
import "../src/easy_legacy_js/context_menu";

window.copyTextToClipboard = function copyTextToClipboard(target) {
  if (target) {
    void copyToClipboard(target.getAttribute("data-clipboard-text"), { noFlash: true });

    const dropdown = $(target).closest(".drdn.expanded");
    if (dropdown.length) {
      dropdown.removeClass("expanded");
    }
  }

  return false;
};
